<template>
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <!-- <H2 style="margin-bottom: 40px">文章管理</H2> -->
        <a-form>
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="文章名称" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="文章类型" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input v-model="table.search.newsName" placeholder="请输入文章名称" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-select placeholder="请选择文章类型" v-model="table.search.category">
                  <a-select-option :value="value.id" v-for="value in table.initData.categoryOptions" :key="value.id">{{
                    value.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-range-picker v-model="table.search.time" class="app-block" show-time
                  valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="8 || 24" :sm="24" style="margin-top: 20px">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="toSearch" style="font-style: italic">查询</a-button>
                <a-button style="margin-left: 8px; font-style: italic" @click="resetSearch">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" style="margin-top: 20px">
        <a-button type="primary" icon="plus" @click="toCreate">新建文章</a-button>
        <!-- <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>
            <a-menu-item key="2"><a-icon type="lock" />上架</a-menu-item>
            <a-menu-item key="2"><a-icon type="lock" />下架</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作 <a-icon type="down" />
          </a-button>
        </a-dropdown> -->
      </div>
      <!-- 表格 -->
      <a-spin tip="加载中..." :spinning="table.loading">
        <a-table :columns="columns" :data-source="table.data" rowKey="id" :pagination="table.page"
          @change="handlePageChange">
          <span slot="status" slot-scope="data">
            <div>
              <a-switch :checked="data.status == '1'" @change="changenewsStatus(data)" />
            </div>
          </span>
          <span slot="action" slot-scope="text, data">
            <template>
              <a @click="handleEdit(data)">编辑</a>
              <a-divider type="vertical" />
              <a @click="handleDelete(data)">删除</a>
            </template>
          </span>
        </a-table>
      </a-spin>
    </a-card>
  </div>
</template>

<script>
import NewsListService from "@/io/news/newsList.js";
import NewsCategoryService from "@/io/news/newsCategory.js";

// 表头
export default {
  name: "newsListPage",
  data() {
    let self = this;
    return {
      categoryResData: {
        data: [
          {
            id: 5,
            name: "游戏",
            remarks: "游戏文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:31",
          },
          {
            id: 4,
            name: "育儿",
            remarks: "育儿文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:24",
          },
          {
            id: 3,
            name: "旅游",
            remarks: "旅游文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:18",
          },
          {
            id: 2,
            name: "健康",
            remarks: "健康文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:10",
          },
          {
            id: 1,
            name: "生活",
            remarks: "生活文章类型",
            status: 1,
            created_at: "2022-03-29 10:47:46",
          },
        ],
        meta: {
          pagination: {
            total: 5,
            count: 5,
            per_page: 15,
            current_page: 1,
            total_pages: 1,
            links: [],
          },
        },
      },
      newsListResData: {
        data: [
          {
            id: 15,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "健康",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:30:18",
          },
          {
            id: 14,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "健康",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:30:17",
          },
          {
            id: 13,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "健康",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:30:16",
          },
          {
            id: 12,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 6,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:38",
          },
          {
            id: 11,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 7,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:37",
          },
          {
            id: 10,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 1,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:36",
          },
          {
            id: 9,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:35",
          },
          {
            id: 8,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:34",
          },
          {
            id: 7,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:33",
          },
          {
            id: 6,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:32",
          },
          {
            id: 4,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:31",
          },
          {
            id: 5,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:31",
          },
          {
            id: 3,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:29",
          },
          {
            id: 2,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:25:28",
          },
          {
            id: 1,
            title: "万事屋有约Vol.1｜本屋开张的第50天",
            category: "生活",
            read_num: 0,
            collection_num: 0,
            status: 1,
            created_at: "2022-03-30 16:24:50",
          },
        ],

        meta: {
          pagination: {
            total: 15,
            count: 15,
            per_page: 15,
            current_page: 1,
            total_pages: 1,
            links: [],
          },
        },
      },
      columns: [
        {
          title: "文章标题",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "类型",
          dataIndex: "category",
          key: "category",
        },
        {
          title: "发布时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "阅读量",
          key: "read_num",
          dataIndex: "read_num",
        },
        {
          title: "收藏量",
          key: "collection_num",
          dataIndex: "collection_num",
        },
        {
          title: "状态",
          key: "status",
          //   dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      table: {
        loading: false,
        data: [],
        search: {
          newsName: null,
          category: [],
          time: null,
        },
        initData: {
          categoryOptions: [],
        },
        page: {
          total: 10,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          },
        },
      },
    };
  },
  activated() {
    this.initnewsList();
  },
  mounted() {
    this.initCategoryData();
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
  },
  methods: {
    //   文章列表数据
    async initnewsList() {
      this.table.loading = true;
      const { page, search } = this.table;
      const res = await NewsListService.list(
        search.newsName,
        search.category,
        search.time,
        page.current,
      );
      // const res = this.newsListResData;
      this.table.data = res.data;
      this.table.page.total = res.meta.pagination.total;
      this.table.loading = false;
    },
    // 初始化文章类型
    async initCategoryData() {
      const res = await NewsCategoryService.list();
      // const res = this.categoryResData
      this.table.initData.categoryOptions = res;
    },
    // 更改状态
    async changenewsStatus({ id, status }) {
      let resStatus = status == "1" ? "0" : "1";
      const res = await NewsListService.status(id);
      let index = this.table.data.findIndex((val) => {
        return val.id == id;
      });
      this.table.data[index].status = resStatus;
    },
    // 详情
    gonewsDetail(id) {
      this.$router.push(`/news/${id}`);
    },
    // 新建文章
    toCreate() {
      this.$router.push("/platform/newslist/new");
    },
    handleAdd() {
      this.mdl = null;
      this.visible = true;
    },
    // 编辑
    handleEdit(data) {
      this.$router.push(`/platform/newslist/new/${data.id}`);
    },
    // 删除
    async handleDelete(data) {
      const res = await NewsListService.delete([data.id]);
      this.initnewsList();
      this.$message.info(res.msg);
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.initnewsList();
    },
    // 搜索
    toSearch() {
      this.table.page.current = 1;
      this.initnewsList();
    },
    // 重置
    resetSearch() {
      this.table.search.newsName = null;
      this.table.search.category = [];
      this.table.search.time = null
    },
  },
};
</script>

